import type {
	FetchParentLinkResponse,
	IssueTypes,
	Projects,
	Issue,
	Option,
	Options,
	TransformedIssueTypes,
	TransformedProjects,
} from './types.tsx';

export const transformIssueTypes = (issueTypes: IssueTypes): TransformedIssueTypes => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const transformedIssueTypes: Record<string, any> = {};
	issueTypes.forEach((issueType) => {
		const { id, iconUrl } = issueType;
		transformedIssueTypes[id] = iconUrl;
	});
	return transformedIssueTypes;
};

export const transformProjects = (projects: Projects): TransformedProjects => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const transformedProjects: Record<string, any> = {};
	projects.forEach((project) => {
		const { id, key } = project;
		transformedProjects[id] = key;
	});
	return transformedProjects;
};

export const mapDataToOptions = (response: FetchParentLinkResponse): Options => {
	const transformedIssueTypes = transformIssueTypes(response.issueTypes);
	const transformedProjects = transformProjects(response.projects);

	const transformedResponse = response.issues.map((issue: Issue) => {
		const { issueKey, issueSummary, issueTypeId, projectId } = issue;
		const projectKey = transformedProjects[projectId];

		return {
			label: `${projectKey}-${issueKey} ${issueSummary}`,
			value: `${projectKey}-${issueKey}`,
			iconUrl: transformedIssueTypes[String(issueTypeId)],
		};
	});
	return transformedResponse;
};

export const mapOptionToData = (option: Option): string => option.value;
